var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.href)?_c('a',{staticClass:"btn",attrs:{"href":_vm.href,"target":"_blank"}},[_c('span',{staticClass:"slot"},[_vm._t("default")],2)]):_c('button',{staticClass:"btn"},[_c('span',{staticClass:"slot"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }